export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6362.fb6ab71b.jpg";